function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { selectEnglishProficiencyTest } from "../../store/Selectors";
import { ENGLISH_EXAM_TYPE_VALUES } from "../../components/CEF/Common/EnglishTests/consts";
export var ToeflScore = /*#__PURE__*/function () {
  function ToeflScore(listening, reading, speaking, writing) {
    _classCallCheck(this, ToeflScore);
    this.listening = listening;
    this.reading = reading;
    this.speaking = speaking;
    this.writing = writing;
  }
  _createClass(ToeflScore, null, [{
    key: "fromDsjState",
    value: function fromDsjState(state) {
      var raw = selectEnglishProficiencyTest(state);
      if ((raw === null || raw === void 0 ? void 0 : raw.value) !== ENGLISH_EXAM_TYPE_VALUES.TOEFL) return null;
      return new ToeflScore(Number(raw.l), Number(raw.r), Number(raw.s), Number(raw.w));
    }
  }]);
  return ToeflScore;
}();